<template>
  <div
    class="container-fluid d-flex align-items-center justify-content-between"
    id="topbar"
  >
    <div>
      <h2 class="m-0">{{ sectionName }}</h2>
    </div>
    <div class="d-flex align-items-center justify-content-around email">
      <div v-if="user.role !== 'superadmin'" class="stripe-button d-flex justify-content-center">
       <button @click="getOnboardingLinkUrl()" :disabled="!this.space || !this.space.stripe" class="d-flex align-items-center p-1">
         <span class="text-center">Go to</span><img src="@/assets/images/brand/logo-stripe.png">
       </button>
      </div>
      <h4 class="m-0">{{ userEmail }}</h4>
    </div>
  </div>
</template>

<script>
import SpaceService from "@/services/space";
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters("utils", ["sectionName"]),
    ...mapGetters("currentUser", ["user"]),
    ...mapGetters("currentUser", ["spaceId"]),
    ...mapGetters("currentUser", ["userEmail"]),
    ...mapGetters("space", ["space"]),
  },
  methods: {
    async getOnboardingLinkUrl() {
      let space = await SpaceService.getSpaceById(this.spaceId)

      if (space.data.status === 'approved') {
        window.open("https://dashboard.stripe.com/login", "_blank")
      }

      if (space.data && space.data.stripe && space.data.stripe.onboarding.link.url) {
        console.log(this.space.stripe.onboarding.link.url);
        window.open(space.data.stripe.onboarding.link.url, "_blank")
        location.reload()
      }
    },
  }
};
</script>

<style lang="scss" scoped>
@import "src/assets/scss/variables";

#topbar {
  height: 100px;
  background: transparent;

  h2 {
    font-family: $mulish;
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    letter-spacing: 0.3px;
  }

  h4 {
    font-family: $mulish;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    letter-spacing: 0.2px;
  }

  .email{
    width: 400px;
    .stripe-button {
       button {
        background: #FFFFFF;
        border: 1px solid #7E4EE2;
        box-sizing: border-box;
        border-radius: 17px;

          span {
            font-family: $inter;
            font-style: normal;
            font-weight: normal;
            font-size: 11px;
            line-height: 14px;
            color: #7E4EE2;
          }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/topbar/Topbar.vue